import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

const EMAIL = "feedback@free-movie-demo.com";

const values = [
  {
    icon: "ri-compass-3-line",
    title: "内容导向",
    desc: "围绕用户查找影片的真实需求组织内容，信息真实、分类清晰、检索高效。",
  },
  {
    icon: "ri-layout-grid-line",
    title: "简洁易用",
    desc: "坚持简洁直观的浏览体验，减少操作步骤，让找片这件事变得轻松。",
  },
  {
    icon: "ri-shield-check-line",
    title: "合规克制",
    desc: "不提供真实播放、下载与会员服务，所有影片信息仅用于展示与学习参考。",
  },
];

const scopes = [
  "最新热门电影信息与详细介绍",
  "优质电视剧集资料与剧集数量",
  "按类型、地区、年份的多维筛选",
  "同类型影片的智能相关推荐",
  "本地收藏片单与浏览记录",
];

export default function About() {
  usePageMeta({
    title: "关于我们 - 免费观看大片在线观看",
    description:
      "了解免费观看大片在线观看网站的定位、服务理念与内容范围。本站汇集热门电影与电视剧资源信息，播放为前端演示，不提供真实流媒体与下载服务。",
    keywords: "关于我们,影视门户,电影资源,电视剧资源,免费观看大片在线观看",
  });

  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
    } catch {
      setCopied(true);
    }
  };

  return (
    <div className="mx-auto max-w-[1400px] px-4 py-6 md:px-6 md:py-8">
      <nav className="flex items-center gap-1.5 text-sm text-foreground-500">
        <Link to="/" className="transition-colors hover:text-primary-500">
          首页
        </Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-800">关于我们</span>
      </nav>

      {/* Hero */}
      <section className="relative mt-4 overflow-hidden rounded-lg border border-background-200/60 bg-background-100/60 p-6 md:p-12">
        <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-primary-500/10 blur-2xl"></div>
        <div className="relative max-w-3xl">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100/80 px-3 py-1 text-xs font-semibold text-accent-900">
            <i className="ri-film-line"></i>
            关于我们
          </span>
          <h1 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
            免费观看大片在线观看
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们是一个面向影视爱好者的综合内容展示与检索门户，聚焦最新热门电影与优质电视剧资源信息，致力于为你提供简洁、高效、内容丰富的浏览体验。
          </p>
        </div>
      </section>

      <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-10">
        <div className="lg:col-span-2">
          {/* 定位 */}
          <section>
            <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <span className="h-5 w-1 rounded-full bg-primary-500"></span>
              网站定位
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
              本站定位为综合影视资源展示平台，重点提供最新与热门电影、电视剧的详细介绍和（演示）观看入口。目标用户是喜欢在线看电影、电视剧的普通观众与影视爱好者，核心需求是快速检索、高效筛选和轻松浏览丰富影视内容。
            </p>
          </section>

          {/* 理念 */}
          <section className="mt-10">
            <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <span className="h-5 w-1 rounded-full bg-primary-500"></span>
              服务理念
            </h2>
            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {values.map((item) => (
                <div
                  key={item.title}
                  className="rounded-lg border border-background-200/60 bg-background-100/50 p-5"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100/70 text-primary-600">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* 内容范围 */}
          <section className="mt-10">
            <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <span className="h-5 w-1 rounded-full bg-primary-500"></span>
              内容范围
            </h2>
            <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {scopes.map((scope) => (
                <li
                  key={scope}
                  className="flex items-start gap-2.5 rounded-md border border-background-200/60 bg-background-100/50 p-3.5 text-sm text-foreground-700"
                >
                  <i className="ri-checkbox-circle-fill mt-0.5 text-primary-500"></i>
                  {scope}
                </li>
              ))}
            </ul>
          </section>

          {/* 声明 */}
          <section className="mt-10">
            <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <span className="h-5 w-1 rounded-full bg-primary-500"></span>
              版权与免责声明
            </h2>
            <div className="mt-4 space-y-3 rounded-lg border border-background-200/60 bg-background-100/50 p-5 text-sm leading-7 text-foreground-600">
              <p>
                本站所有影视资料、海报图片及相关信息均来自公开渠道，仅用于内容展示、信息索引与学习交流，版权归原作者及权利方所有。
              </p>
              <p>
                站内影视播放为前端功能演示，<strong className="text-foreground-900">不接入真实流媒体资源，不提供下载或会员服务</strong>，也不展示虚假的加载或播放成功状态。
              </p>
              <p>
                如相关内容涉及版权问题，请通过下方邮箱与我们联系，我们将在核实后及时处理。
              </p>
            </div>
          </section>
        </div>

        {/* Sidebar */}
        <aside className="lg:col-span-1">
          <div className="sticky top-24 space-y-6">
            <section className="rounded-lg border border-background-200/60 bg-background-100/50 p-5">
              <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-mail-send-line text-primary-500"></i>
                联系我们
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                如有内容建议、资源反馈或版权问题，欢迎通过邮箱与我们取得联系。
              </p>
              <button
                type="button"
                onClick={handleCopy}
                className="group mt-4 flex w-full items-center justify-between rounded-md border border-background-200/70 bg-background-50 px-4 py-3 text-left transition-colors hover:border-primary-400"
              >
                <span className="min-w-0">
                  <span className="block text-xs text-foreground-500">反馈邮箱</span>
                  <span className="mt-0.5 block truncate text-sm font-medium text-foreground-900">
                    {EMAIL}
                  </span>
                </span>
                <span className="ml-3 flex shrink-0 items-center gap-1 text-xs font-medium text-primary-500">
                  <i className={copied ? "ri-check-line" : "ri-file-copy-line"}></i>
                  {copied ? "已复制" : "复制"}
                </span>
              </button>
            </section>

            <section className="rounded-lg border border-background-200/60 bg-background-100/50 p-5">
              <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-links-line text-primary-500"></i>
                快速入口
              </h2>
              <div className="mt-4 space-y-2.5">
                <Link
                  to="/movies"
                  className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-200/50 hover:text-primary-500"
                >
                  <span className="flex items-center gap-2">
                    <i className="ri-movie-2-line"></i>
                    浏览电影
                  </span>
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
                <Link
                  to="/tvshows"
                  className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-200/50 hover:text-primary-500"
                >
                  <span className="flex items-center gap-2">
                    <i className="ri-tv-2-line"></i>
                    浏览电视剧
                  </span>
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
                <Link
                  to="/search"
                  className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-200/50 hover:text-primary-500"
                >
                  <span className="flex items-center gap-2">
                    <i className="ri-search-line"></i>
                    搜索影片
                  </span>
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
            </section>
          </div>
        </aside>
      </div>
    </div>
  );
}